import {Injectable}                                           from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable}                                           from 'rxjs';
import {Schema}                                               from '../api/bases/proxy/schemas/schema.interface';
import {Api}                                                  from '../api.service';

@Injectable()
class SchemaResolver implements Resolve<Observable<Schema>> {
    constructor(private api: Api) {}

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Schema> {
        const baseId: number   = route.params[route.data['schemaBaseIdentifier']];
        const schemaId: number = route.params[route.data['schemaRouteIdentifier']];

        return this.api.bases().proxy(baseId).schemas().resource(schemaId);
    }
}

export {
    SchemaResolver
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/resolvers/schemas.resolver.ts